import React, {Component} from 'react'
import ReturnStep1 from "./ReturnStep1.jsx"
// import ReturnStep2 from "./ReturnStep2.jsx"
// import ReturnStep3 from "./ReturnStep3.jsx"
import ReturnConfirm from "./ReturnConfirm.jsx"
// import dayjs from 'dayjs'

class Return extends Component {
  constructor(props) {
    super(props)
    const initialLineId = props.orderId
    console.log('initialLineId', initialLineId)
    const reason = props.reason
    const order = props.json
    if(initialLineId) {
      order.line_items.forEach(item => {
        if(item.id == initialLineId) {
          item.selectedAsReturn = true
          item.returnReason = reason
          item.returnQty = 1
        }
      })
    }
    this.state = {
      initialLineId: initialLineId,
      order: order,
      reason: reason,
      step: 1,
      returnType: window.accountStrings.order.byCourier,
      pickupAddress: {
        first_name: null,
        last_name: null,
        country: null,
        street: null,
        city: null,
        province: null,
        zip: null,
        phone: null,
      },
      result: null,
      // timePeriod: {
      //   date: dayjs(),
      //   timeFrom: null,
      //   timeTo: null,
      // }
    }
    console.log('state', this.state.order)
  }

  componentDidMount() {
    if(document.querySelector('[data-section-type="main-order"]')) {
      document.querySelector('[data-section-type="main-order"]').classList.add('!hidden')
    }
    if(document.querySelector('[data-section-type="customer-services"]')) {
      document.querySelector('[data-section-type="customer-services"]').classList.add('!hidden')
    }
  }

  updateOrder = (order) => {
    this.setState({ order, })
    setTimeout(() => {
      console.log('prop order', order)
    }, 150)
  }
  updateAddress = (pickupAddress) => {
    this.setState({ pickupAddress, })
    setTimeout(() => {
      console.log('prop pickupAddress', this.state.pickupAddress)
    }, 150)
  }
  // updatePeriod = (timePeriod) => {
  //   this.setState({ timePeriod, })
  //   setTimeout(() => {
  //     console.log('prop timePeriod', this.state.timePeriod)
  //   }, 150)
  // }

  goNextStep = (step=2) => {
    if(step == 2 && this.state.order.line_items.filter(item => item.selectedAsReturn).length > 0) {
      fetch(`https://${window.tbApiDomain}/create_return`, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          Accept: 'application/json'
        }),
        body: JSON.stringify(
          {
            "return": {
                "order_id": this.state.order.id,
                "return_line_items": this.state.order.line_items.filter(item => item.selectedAsReturn).map(item => {
                  return {
                    "id": item.id,
                    "quantity": item.returnQty,
                    "reason": item.returnReason,
                    "note": item.additionalReason
                  }
                })
            }
          }
        ),
      })
        .then((response) => response.json())
        .then((result) => {
          console.log(result)
          this.setState({result: result})
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          this.setState({ step, })
        })
    }
    // else if(step == 3 && this.state.pickupAddress.first_name && this.state.pickupAddress.country && this.state.pickupAddress.street && this.state.pickupAddress.city && this.state.pickupAddress.zip && this.state.pickupAddress.phone) {
    //   this.setState({ step, })
    // } else if(step == 4 && this.state.timePeriod.date && this.state.timePeriod.timeFrom && this.state.timePeriod.timeTo) {
    //   this.setState({ step, })
    // } else if(step == 5 && this.state.order.line_items.filter(item => item.selectedAsReturn).length) {

    // }
  }

  saveBtnClasses = () => {
    switch (this.state.step) {
      case 1:
        return !!this.state.order.line_items.filter(item => item.selectedAsReturn).length ? 'button--primary' : 'button--secondary'
      // case 2:
      //   return this.state.pickupAddress.first_name && this.state.pickupAddress.country && this.state.pickupAddress.street && this.state.pickupAddress.city && this.state.pickupAddress.zip && this.state.pickupAddress.phone ? 'button--secondary' : 'button--primary'
      // case 3:
      //   return this.state.timePeriod.date && this.state.timePeriod.timeFrom && this.state.timePeriod.timeTo ? 'button--secondary' : 'button--primary'
      default:
        break
    }

    return !!this.state.order.line_items.filter(item => item.selectedAsReturn).length ? 'button--primary' : 'button--secondary'
  }

  render() {
    return (
      <div className='container'>
        <div className={`lg:border-fore lg:border-y ${this.state.step < 2 ? 'lg:grid lg:grid-cols-3' : ''}`}>
          <div className={`pb-5 lg:py-12.5 ${this.state.step < 2 ? 'lg:border-r lg:border-fore lg:pr-12.5 col-span-2' : 'max-w-[56.25rem] text-center mx-auto'}`}>
            <div className={`flex items-center gap-4 mb-5 lg:mb-11 pb-5 lg:pb-0 mt-10 lg:mt-0 border-b border-fore lg:border-b-0 ${this.state.step < 2 ? 'justify-between' : 'justify-center'}`}>
              <h1 className="text-sm">
                { this.state.step < 2 ? window.accountStrings.order.makeReturn : window.accountStrings.order.returnConfirmation }
              </h1>
              {/* <div className={`normal-case text-xs ${ this.state.step < 4 ? '' : 'hidden' }`}>
                <button className='cursor-pointer'
                  onClick={e => this.setState({ step: 1 })}
                >
                  1. Items
                </button>
                <span className={ this.state.step < 2 ? 'opacity-30' : '' }>
                  &nbsp;–––&nbsp;
                </span>
                <button className={ `cursor-pointer ${this.state.step < 2 ? 'opacity-30' : ''}` }
                  onClick={e => this.setState({ step: this.state.step >= 2 ? 2 : 1 })}
                >
                  2. Address
                </button>
                <span className={ this.state.step < 3 ? 'opacity-30' : '' }>
                  &nbsp;–––&nbsp;
                </span>
                <button className={ `cursor-pointer ${this.state.step < 3 ? 'opacity-30' : ''}` }
                  onClick={e => this.setState({ step: this.state.step >= 3 ? 3 : this.state.step })}
                >
                  3. Date
                </button>
              </div> */}
            </div>
            { this.state.step == 1 &&
              <ReturnStep1 order={this.state.order}
                updateOrder={this.updateOrder}
              />
            }
            {/* { this.state.step == 2 &&
              <ReturnStep2 pickupAddress={this.state.pickupAddress}
                order={this.state.order}
                updateAddress={this.updateAddress}
              />
            }
            { this.state.step == 3 &&
              <ReturnStep3 updatePeriod={this.updatePeriod} timePeriod={this.state.timePeriod} />
            } */}
            { this.state.step == 2 &&
              <ReturnConfirm order={this.state.order} result={this.state.result} />
            }
          </div>
          {
            this.state.step < 2 &&
            <div className='py-5 lg:py-12.5 lg:pl-12.5 border-t border-fore lg:border-t-0'>
              <h2 className='text-sm mb-5'>{window.accountStrings.order.summary}</h2>
              <div className='py-5 border-y border-fore normal-case flex flex-col gap-2.5 mb-5 text-xs'>
                <div className='flex items-center justify-between'>
                  <span className='normal-case text-fourth-grey'>{window.accountStrings.order.returnType}</span>
                  <span className='normal-case'>{ this.state.returnType }</span>
                </div>
                <div className='flex items-center justify-between'>
                  <span className='normal-case text-fourth-grey'>{window.accountStrings.order.noOfItems}</span>
                  <span className='normal-case'>{ this.state.order.line_items.filter(item => item.selectedAsReturn).length }</span>
                </div>
              </div>
              <div className='normal-case text-fourth-grey text-xs mb-7.5'>
                By proceeding I agree to the Thom Browne&nbsp;
                <a className='underline' href='/pages/returns' title='opens in a new window' target='_blank'>returns policy</a>
                &nbsp;and the items I am returning are being returned conforming to that policy.
                <br /><br />
                By confirming the booking for this return, you certify that the items being returned are unworn, undamaged and unused, and otherwise comply with Thom Browne’s&nbsp;
                <a className='underline' href='/pages/returns' title='opens in a new window' target='_blank'>returns policy</a>,
                and you affirm that you have assigned to Thom Browne any right to or interest in duty drawback that you may have the respect to the returned items.
              </div>
              {
                this.state.step < 2 &&
                <>
                  <button className={`button w-full mb-2.5 relative ${this.saveBtnClasses()}`}
                    onClick={e => {
                      this.goNextStep(this.state.step + 1)
                      e.target.classList.add('button--loading')
                    }}
                  >
                    {window.accountStrings.order.submitReturn}
                    <div className="button--loading__pane">
                      <span className="button--loading__dot"></span>
                      <span className="button--loading__dot"></span>
                      <span className="button--loading__dot"></span>
                    </div>
                  </button>
                  <button className='button button--secondary w-full mb-6.25'
                    onClick={e => {window.removeOrderReturn()}}
                  >
                    {window.accountStrings.order.cancel}
                  </button>

                  <div className='text-right'>
                    <a className='underline text-xs underline-offset-2' href={ this.state.initialLineId ? '/account' : '/pages/returns'}>
                      { this.state.initialLineId ? window.accountStrings.order.backToAccount : window.accountStrings.order.back}
                    </a>
                  </div>
                </>
              }
            </div>
          }
        </div>
      </div>
    )
  }
}

export default Return